import { useEffect } from 'react';

import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalFooter,
} from '@grupoboticario/flora-react';

import { ModalText, ButtonFooter } from './styles';

interface IModalError {
  errorReason: string;
  errorResponse: string;
  setIsOpen: any;
  isOpen: boolean;
}

export const ModalError = (props: IModalError): JSX.Element => {
  const { setIsOpen, isOpen, errorReason = '', errorResponse = '' } = props;

  const navigateToHome = () => {
    setIsOpen(false);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {}, []);

  return (
    <Modal open={isOpen} onOpenChange={closeModal}>
      <ModalContent size="small">
        <ModalCloseButton />
        <ModalHeader />
        <ModalBody>
          <ModalText>
            <span>Erro</span>
            <p className="reason">{errorReason}</p>
            <p className="response">{errorResponse}</p>
          </ModalText>
        </ModalBody>
        <ButtonFooter>
          <Button size="small" onClick={() => navigateToHome()}>
            OK
          </Button>
        </ButtonFooter>
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};
